/**
 * Styling constants for embedded Google Maps (iframe).
 * The map tiles themselves cannot be themed; we style the frame to match the app.
 */
export const MAP_EMBED_CONFIG = {
  /** Outer gradient ring thickness (Chakra space token scale) */
  framePadding: "2px",
  /** Outer corner radius */
  outerRadius: "14px",
  /** Inner clip radius (should be outerRadius minus frame padding visually) */
  innerRadius: "12px",
  /** Heights per breakpoint */
  height: { base: "220px", md: "320px" },
} as const;
